<template>
  <div class="filter dining-party-size">
    <div
      class="ais-RangeInput"
      v-if="state"
    >
      <div class="dining-party-size-slider">
        <vue-slider
          ref="slider"
          :marks="true"
          :min="1"
          :max="12"
          :adsorb="true"
          :precision="0"
          :tooltip="'always'"
          :value="values.min || 2"
          @change="handleChange"
        >
          <template v-slot:label="{active}">
            <img
              :class="{
                'dining-party-size-slider-diner-mark': true, 'dining-party-size-slider-diner-mark--not-active': !active
              }"
              :src="personIcon"
            />
          </template>
          <template v-slot:tooltip="{ value }">{{ value }}</template>
        </vue-slider>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import { createWidgetMixin } from 'vue-instantsearch';
import { connectRange } from 'instantsearch.js/es/connectors';
// this is the only difference with the official widget
import { createPanelConsumerMixin } from '../mixins/panel';

export default {
  mixins: [
    createWidgetMixin({ connector: connectRange }),
    // & its usage is also changed
    createPanelConsumerMixin({
      mapStateToAppliedRefinements: state =>
        state && state.start[0] > 0 ? state.start[0] : 0,
    }),
  ],
  data() {
    return {
      widgetParams: {
        attribute: 'max_diners',
      },
    };
  },
  components: {
    VueSlider,
  },
  // copied from real component
  computed: {
    values() {
      const [minValue, maxValue] = this.state.start;
      const { min: minRange, max: maxRange } = this.state.range;

      return {
        min: minValue !== -Infinity && minValue !== minRange ? minValue : null,
        max: maxValue !== Infinity && maxValue !== maxRange ? maxValue : null,
      };
    },
    personIcon() {
      if (document.body.className.includes('gourmet-society')) {
        return require('@/assets/icons/person-pink.png');
      }
      return require('@/assets/icons/person.png');
    },
  },
  methods: {
    handleChange(event) {
      if (event === 1) {
        this.$refs.slider.setValue(2);
      } else {
        this.state.refine([event]);
      }
    },
  },
};
</script>

<!-- not scoped scss because we mostly do global css here -->
<style lang="scss">
.dining-party-size {
  &-slider {
    height: 100%;
    &-diner-mark {
      width: 100%;

      .gourmet-society &--not-active {
        filter: grayscale(1) opacity(0.5);
      }
    }
  }
}

.ais-RangeInput {
  height: 65px;
  margin: 24px 0;
  padding: 0 10px;
}
.vue-slider {
  height: 100% !important;
  padding: 0 !important;
  &-marks {
    margin-top: -55px;
  }
  &-mark {
    width: 9px !important;
    cursor: pointer;
  }
  &-rail {
    position: absolute !important;
    bottom: 0 !important;
    height: 8px !important;
    background: $gallery-grey;
  }
  &-dot {
    width: 22px !important;
    height: 22px !important;
    @include theme-value(background-color, brand-color-one);
    border-radius: 100%;
    cursor: pointer;
    .gourmet-society & {
      border-radius: 0;
    }
  }
  &-dot-tooltip {
    top: 17px !important;
    color: $white;
    font-weight: 700;
  }
}
</style>
